import proxyapi from "./ProxyApi";

/**
 * Service for handling inquiry-related API calls
 */
const inquiryService = {
  /**
   * Submit a new inquiry
   * 
   * @param {Object} inquiryData - Inquiry data
   * @param {string} inquiryData.name - Name of the person
   * @param {string} inquiryData.email - Email address
   * @param {string} inquiryData.subject - Inquiry subject
   * @param {string} inquiryData.message - Inquiry message
   * @param {boolean} inquiryData.authenticated - Whether user is authenticated
   * @param {string|null} inquiryData.userId - User ID if authenticated
   * @returns {Promise} - Promise that resolves to the response data
   */
  submitInquiry: async (inquiryData) => {
    try {
      const response = await proxyapi.post('/api/v1/inquiries', inquiryData);
      return response.data;
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      throw error;
    }
  },
};

export default inquiryService;